import { FC, MutableRefObject, ReactNode, useState } from 'react'
import { Map } from 'pigeon-maps'
import { Box, MantineStyleProp, useComputedColorScheme } from '@mantine/core'
import { GeographicCoordinates } from '@/api/navigationApi/types.gen'

const CARTO_DARK_SUBDOMAINS = ['a', 'b', 'c', 'd'] as const
const darkTileProvider = (x: number, y: number, z: number): string =>
  `https://${CARTO_DARK_SUBDOMAINS[(x + y) % CARTO_DARK_SUBDOMAINS.length]}.basemaps.cartocdn.com/dark_all/${z}/${x}/${y}@2x.png`

const MapViewer: FC<{
  center: GeographicCoordinates
  zoom: number
  overlays: Array<ReactNode>
  className?: string
  sx?: MantineStyleProp
  maxZoom?: number
  onZoom?: (zoom: number) => void
  onCenterChanged?: (center: GeographicCoordinates) => void
  containerRef?: MutableRefObject<HTMLDivElement>
  addons?: Array<ReactNode>
}> = ({ center, zoom, overlays, className, sx, maxZoom, onZoom, onCenterChanged, containerRef, addons = [] }) => {
  const colorScheme = useComputedColorScheme('light')
  const [, setBounds] = useState<{
    northEast: GeographicCoordinates
    southWest: GeographicCoordinates
  }>()

  return (
    <Box className={className} ref={containerRef} style={[sx, { position: 'relative' }]}>
      <Map
        provider={colorScheme === 'dark' ? darkTileProvider : undefined}
        maxZoom={maxZoom}
        center={[center.latitude, center.longitude]}
        zoom={zoom}
        onBoundsChanged={({ bounds, zoom, center, initial }) => {
          if (!initial) {
            onZoom?.(zoom)
            onCenterChanged?.({ latitude: center[0], longitude: center[1] })
          }
          setBounds({
            northEast: { latitude: bounds.ne[0], longitude: bounds.ne[1] },
            southWest: { latitude: bounds.sw[0], longitude: bounds.sw[1] },
          })
        }}
      >
        {overlays}
      </Map>
      {addons}
    </Box>
  )
}

export default MapViewer
